import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import StrategyRoutes from '../../Component/Layouts/AllStrategy';


const mdTheme = createTheme();

function MainStrategy() {

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Strategy"/>
        <StrategyRoutes />
      </Box>
    </ThemeProvider>
  );
}

export default function Strategy() {
  return <MainStrategy />
}